import { ImageOff } from 'lucide-react';
import { useStorageUrl } from '@/hooks/useStorageUrl';
import { cn } from '@/lib/utils';

interface StorageImageProps {
  path: string | undefined;
  alt: string;
  className?: string;
}

/**
 * An image whose source is a Storage *path*. Renders a neutral tile while the
 * URL resolves, and a placeholder if there is no path or the file is gone.
 */
export function StorageImage({ path, alt, className }: StorageImageProps) {
  const url = useStorageUrl(path);

  if (url) {
    return <img src={url} alt={alt} loading="lazy" className={cn('object-cover', className)} />;
  }
  return (
    <div
      className={cn('bg-muted text-muted-foreground flex items-center justify-center', className)}
      aria-hidden="true"
    >
      {path ? null : <ImageOff className="size-5" />}
    </div>
  );
}
